<template>
  <div class="receipts-help-container">
    <b-card class="mb-4">
      <h2 class="mb-4">{{ $t('message.receipts_help') }}</h2>
      
      <div class="alert alert-info mb-4">
        <h4 class="alert-heading">{{ $t('message.automatic_receipts_generation') }}</h4>
        <p>
          מערכת זו מאפשרת הפקת קבלות אוטומטית בעת ייבוא עסקאות מנדרים פלוס. 
          כדי להשתמש בתכונה זו, יש להגדיר מספר הגדרות חשובות.
        </p>
      </div>
      
      <h3 class="mb-3">{{ $t('message.receipts_setup_guide') }}</h3>
      
      <div class="setup-steps">
        <!-- שלב 1 -->
        <div class="setup-step mb-4">
          <div class="step-header">
            <div class="step-number">1</div>
            <h4>{{ $t('message.step_1') }}</h4>
          </div>
          <div class="step-content">
            <p>
              יש להגדיר את האפשרות "הפקת קבלות אוטומטית" בדף הגדרות הפרויקט:
            </p>
            <ol>
              <li>גש לדף <b-link to="/admin/project-settings">הגדרות פרויקט</b-link></li>
              <li>סמן את האפשרות "הפקת קבלות אוטומטית"</li>
              <li>לחץ על "שמור הגדרות"</li>
            </ol>
            <div class="text-center mt-3">
              <b-button variant="primary" to="/admin/project-settings">
                <i class="zmdi zmdi-settings mr-2"></i>
                גש להגדרות פרויקט
              </b-button>
            </div>
          </div>
        </div>
        
        <!-- שלב 2 -->
        <div class="setup-step mb-4">
          <div class="step-header">
            <div class="step-number">2</div>
            <h4>{{ $t('message.step_2') }}</h4>
          </div>
          <div class="step-content">
            <p>
              יש להגדיר מפתח API תקף לשירות הקבלות:
            </p>
            <ol>
              <li>גש לדף <b-link to="/admin/management_api_keys">ניהול מפתחות API</b-link></li>
              <li>לחץ על "הוסף מפתח API חדש"</li>
              <li>בחר בסוג שירות "הפקת קבלות"</li>
              <li>הזן את פרטי המפתח הנדרשים</li>
              <li>סמן את האפשרות "הגדר כברירת מחדל"</li>
              <li>לחץ על "שמור"</li>
            </ol>
            <div class="text-center mt-3">
              <b-button variant="primary" to="/admin/management_api_keys">
                <i class="zmdi zmdi-key mr-2"></i>
                גש לניהול מפתחות API
              </b-button>
            </div>
          </div>
        </div>
        
        <!-- שלב 3 -->
        <div class="setup-step mb-4">
          <div class="step-header">
            <div class="step-number">3</div>
            <h4>{{ $t('message.step_3') }}</h4>
          </div>
          <div class="step-content">
            <p>
              לאחר הגדרת האפשרויות הנדרשות, ניתן לייבא עסקאות מנדרים פלוס:
            </p>
            <ol>
              <li>גש לדף <b-link to="/admin/commitments">התחייבויות</b-link></li>
              <li>בחר בלשונית "יבא התחייבויות מנדרים"</li>
              <li>בחר בקובץ לייבוא</li>
              <li>לחץ על "ייבא כעת"</li>
            </ol>
            <div class="text-center mt-3">
              <b-button variant="primary" to="/admin/commitments">
                <i class="zmdi zmdi-file-plus mr-2"></i>
                גש לייבוא התחייבויות
              </b-button>
            </div>
          </div>
        </div>
      </div>
      
      <div class="alert alert-warning mt-4">
        <h5 class="alert-heading">{{ $t('message.important_note') }}</h5>
        <p>
          שים לב: אם מתרחשת שגיאה בעת ייבוא עסקאות, המערכת תציג הודעת שגיאה מפורטת עם הנחיות לפתרון הבעיה.
          במקרה של שגיאה, וודא שהגדרת את כל האפשרויות הנדרשות כמתואר לעיל.
        </p>
      </div>
      
      <div class="mt-4 text-center">
        <b-button variant="outline-secondary" to="/admin/project-settings" class="mr-2">
          {{ $t('message.back_to_settings') }}
        </b-button>
        <b-button variant="outline-secondary" to="/admin/management_api_keys">
          {{ $t('message.back_to_api_keys') }}
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'ReceiptsHelp'
};
</script>

<style scoped>
.receipts-help-container {
  max-width: 800px;
  margin: 0 auto;
}

.setup-steps {
  margin: 2rem 0;
}

.setup-step {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}

.step-header {
  display: flex;
  align-items: center;
  background-color: #f8f9fa;
  padding: 1rem;
  border-bottom: 1px solid #e0e0e0;
}

.step-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #007bff;
  color: white;
  font-weight: bold;
  margin-left: 1rem;
}

.step-content {
  padding: 1.5rem;
}

h4 {
  margin: 0;
}

ol {
  padding-right: 1.5rem;
  margin-bottom: 0;
}

li {
  margin-bottom: 0.5rem;
}

li:last-child {
  margin-bottom: 0;
}
</style>
